<template>
  <div class="keyword-select" ref="selectStartInput">
    <el-input class="search-text is-input"
              :class="{'is-clear':clearable}"
              :placeholder="isHasSelectValue?'':placeholder"
              v-popover:startPopover
              v-model="searchText"
              :disabled="disabled"
              @click.stop="noEvent"
              @blur="handlerBlur"
              @focus="handlerFocus"
              @change="handlerChange"
              @keyup.enter.native="handlerEnter"
    ></el-input>
    <div class="value-text"
         :class="[showTextStatus,clearable?'is-clear':'']"
    >
      <slot>
        <div class="text-row">
          {{ multipleShowName }}
        </div>
      </slot>
    </div>
    <div class="btn-delete" v-if="clearable && isHasSelectValue && !disabled">
      <i class="icon el-icon-circle-close" @click="clickClear"></i>
    </div>
    <el-popover
      popper-class="input-popover-template-popper"
      :visible-arrow="false"
      ref="startPopover"
      trigger="manual"
      placement="bottom-start"
      @show="handlerShow"
      :width="popoverWidth"
      :offset="offset"
      v-model="visiblePopover"
    >
      <div class="alter-place-bpx">
        <template v-if="list.length || historySearchList.length">
          <div v-if="historySearchList && historySearchList.length > 0">
            <div class="history-search">
              <div>历史记录</div>
              <div class="clear-history" @click="clearHistory">清除历史</div>
            </div>
            <div class="group-wrap">
              <div
                class="group-wrap__item"
                :class="{'is-active':judgeItemIsSelect(item)}"
                v-for="item in historySearchList"
                :key="item.hotsearchName"
                @click="selectItem(item)"
              >
                <template v-if="item.hotsearchName.length < 5">
                  {{ item.hotsearchName }}
                </template>
                <template v-else>
                  <el-tooltip placement="top" :content="item.hotsearchName">
                    <div class="overflow">{{ item.hotsearchName }}</div>
                  </el-tooltip>
                </template>
              </div>
            </div>
          </div>
          <div :class="{'hot-search-wrap': historySearchList && historySearchList.length > 0}">
            <div class="hot-search">热门搜索</div>
            <div class="group-wrap">
              <div
                class="group-wrap__item"
                :class="{'is-active':judgeItemIsSelect(item)}"
                v-for="item in list"
                :key="item.hotsearchName"
                @click="selectItem(item)"
              >
                <template v-if="item.hotsearchName.length < 5">
                  {{ item.hotsearchName }}
                </template>
                <template v-else>
                  <el-tooltip placement="top" :content="item.hotsearchName">
                    <div class="overflow">{{ item.hotsearchName }}</div>
                  </el-tooltip>
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="isLoading">
          <div class="hint-row"><i class="el-icon-loading"></i> {{ loadingText }}</div>
        </template>
        <template v-else>
          <div class="hint-row"><i class="el-icon-warning-outline"></i> {{ noDataMessage }}</div>
        </template>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {isArray, isObject} from "my-tools-kit";

export default {
  name: "keywordSelect",
  props: {
    multiple:{ // 是否支持多选
      type:Boolean,
      default:false,
    },
    value:{ // 选中值,单选Object,多选Array
      type:[Object,Array],
      default:()=>({}),
    },
    clearable:{ // 是否可清空
      type:Boolean,
      default:true,
    },
    disabled:{ // 输入框是否禁用，禁用情况下点击输入框页无法弹出列表
      type:Boolean,
      default:false,
    },
    placeholder:{ //输入框提示信息
      type:String,
      default:"请输入渠道名称查询/专线名称查询",
    },
    maxSelectNumber:{ //最大选择数量,为零时不限制，只在选择某个item操作后截断处理。
      type:Number,
      default:0,
    },
    list:{ // 列表
      type:Array,
      default:()=>[],
    },
    isLoading:{ // 显示 正在请求数据中...
      type:Boolean,
      default:false,
    },
    loadingText:{
      type:String,
      default:"正在请求数据中...",
    },
    noDataMessage:{ //列表为空时的提示信息
      type:String,
      default:"暂未找到您要的信息",
    },
    popoverWidth:{ //弹出层宽度
      type:String,
      default:"438",
    },
    offset:{ //出现位置的偏移量
      type:Number,
      default:0,
    },
    idKey:{ // 对选中数据进行匹配校验的字段
      type:String,
      default:"hotsearchName",
    },
  },
  data() {
    return {
      searchText:"",//输入框搜索文本
      selectedValue:[],
      visiblePopover:false,// 显示弹出层
      historySearchList: JSON.parse(localStorage.getItem('history-search')) || []
    }
  },
  computed: {
    /**
     * 回显文本状态 class
     * @returns {string}
     */
    showTextStatus(){
      // 搜索框有输入值
      if(this.searchText.length) return "opacity-0"
      // 搜索框没有输入值，但是聚焦状态
      if(this.isFocus) return "opacity-04"
      return "";
    },
    /**
     * 是否有选中值
     * @returns {*}
     */
    isHasSelectValue(){
      // 有选中值时 输入框不显示placeholder
      let list = this.selectedValue;
      return isArray(list) && list.length && list.some((res={})=>res[this.idKey]||res[this.idKey]===0);

      // if(this.multiple){
      //   return isArray(this.value) && this.value.length && this.value.some((res={})=>res[this.idKey]||res[this.idKey]===0);
      // }else{
      //   return this.value[this.idKey]||this.value[this.idKey]===0
      // }
    },
    /**
     * 多选时展示的选中文本
     */
    multipleShowName(){
      let list = this.selectedValue;
      if(!isArray(list)) return "";
      return list.map((res={})=>{
        return res[this.labelKey]|| res[this.idKey]
      }).join(",");
    },
  },
  watch: {
    value:{
      immediate:true,
      handler: function (newValue) {
        this.selectedValue = this.receiveDefaultValue(this.value);
      },
    },
  },
  methods: {
    /**
     * 根据 单选/多选 类型处理默认选中值为selectValue所需的格式
     */
    receiveDefaultValue(value){
      let list = [];
      if(this.multiple){
        if(isArray(value)) list = value.concat([]);
      }else{
        if(isObject(value)) list = [value];
      }
      return list;
    },
    /**
     * 失去焦点时触发
     */
    handlerBlur(){
      this.isFocus = false;
      this.$emit('blur', this.searchText);
      // this.hideListPopover();
    },
    handlerChange(val) {
      this.$emit('inputChange', val)
    },
    /**
     * 获得焦点时触发
     */
    handlerFocus(){
      this.isFocus = true;
      this.$emit('focus');
      this.showListPopover();
    },
    /**
     * 按下回车时触发
     */
    handlerEnter(){
      console.log('按下回车')
      this.$emit('keyup', this.searchText);
    },
    /**
     * 清空
     */
    clickClear(){
      let value;
      if(this.multiple){
        value = [];
      }else{
        value = {};
      }
      this.$emit("input",value);
      this.$emit("change",value);
      this.$emit("clear",value);
    },
    handlerShow(){ //显示时触发
      this.$emit("show");
    },
    /**
     * 空函数
     * */
    noEvent(){},
    /**
     * 显示、隐藏列表
     */
    showListPopover(){
      this.visiblePopover = true;
      this.historySearchList = JSON.parse(localStorage.getItem('history-search')) || []
      this.$emit("update:visible",true);
    },
    hideListPopover(e){
      this.visiblePopover = false;
      if(this.multiple){
        this.selectedValue = this.receiveDefaultValue(this.value);
      }
      // this.searchText = "";
    },
    selectItem(item) {
      this.searchText = ''
      let list = this.selectedValue;
      if(this.multiple){
        const index = list.findIndex((res={})=>res.id === item.id);
        if(index >=0) {
          list.splice(index,1);
        }else{
          list.push(item);
        }
        if(this.maxSelectNumber && list.length > this.maxSelectNumber){
          list.splice(0,list.length - this.maxSelectNumber);
        }
        if(this.maxSelectNumber === 1){
          this.$emit("input",list);
          this.$emit("change",list);
          this.hideListPopover();
        }else{
          // 一个以上的选择点击确认按钮
        }
      }else{
        list = [item];
        this.$emit("input",item);
        this.$emit("change",item);
        this.hideListPopover();
      }
    },
    /**
     * 判断某项值是否选中
     */
    judgeItemIsSelect(item={}){
      let list = this.selectedValue;
      return isArray(list) && list.some((res={})=>res[this.idKey] === item[this.idKey]);
      // if(this.multiple){
      //   return isArray(this.value) && this.value.some((res={})=>res[this.idKey] === item[this.idKey]);
      // }else{
      //   return this.value[this.idKey] === item[this.idKey];
      // }
    },
    clearHistory() {
      this.historySearchList = []
      localStorage.removeItem('history-search')
    },
    /**
     * 全局关闭
     */
    globalClosePopover(e){
      let screenDoc = this.$refs.selectStartInput;
      if (screenDoc && !screenDoc.contains(e.target)) {
        this.hideListPopover()
      }
    },
  },
  created() {
    document.addEventListener("click",this.globalClosePopover,false);
  },
  destroy() {
    this.selectedValue = []
    document.removeEventListener("click",this.globalClosePopover);
  },
}
</script>

<style lang="less" scoped>
.keyword-select {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;

  /* 默认样式 */
  width: 100%;
  height: 50px;
  background-color: #F5F5F5;
  border-radius: 10px;

  /deep/ .el-input__inner{
    height: inherit;
    line-height: inherit;
  }
}
/* 搜索框 */
.search-text{
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  font-size: 16px;
  &,
  /deep/ input{
    background-color: transparent !important;
  }
  /deep/ input{
    min-width: auto;
    width: 100%;
    height: 100%;
    border: none;
  }
  &:not([class~="is-input"]){
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 15px;
    cursor: pointer;
    color: #999;
  }
  &.is-clear{
    /deep/ input{
      padding-right: 0;
    }
    &:not([class~="is-input"]){
      padding-right: 0;
    }
  }
}
/* 弹出框内容 */
.alter-place-bpx{
  padding: 15px 11px 13px;
  font-size: 16px;
}
.opacity-0{
  opacity: 0;
}
.opacity-04{
  opacity: 0.4;
}
/* 选中值回显文本 */
.value-text{
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  transition: opacity 0.4s ease;
  &.is-clear{
    right: 30px;
  }
}
.text-row{
  padding: 0 11px;
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.btn-delete{
  position: relative;
  z-index: 1;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  .icon{
    cursor: pointer;
    color: #c0c4cc;
    &:hover{
      color: #909399;
    }
  }
}
.group-wrap {
  display: flex;
  flex-wrap: wrap;
  &__item {
    width: 87px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 11px;
    margin-top: 14px;
    padding: 0 2px;
    background: #EEEEEE;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    .overflow {
      width: 87px;
      height: 100%;
      text-align: center;
      overflow:hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 30px;
    }
    &:hover {
      cursor: pointer;
    }
    &.is-active {
      background: #FF4D01;
      color: #FFFFFF;
    }
  }
}
.hot-search {
  font-size: 18px;
  font-weight: 500;
  color: #333333;
}
.history-search {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 500;
  color: #333333;
}
.clear-history {
  color: #FF4D01;
  &:hover {
    cursor: pointer;
  }
}
.hot-search-wrap {
  margin-top: 27px;
}
</style>



// WEBPACK FOOTER //
// common/newSelectPlace/selectKeyword.vue